function ValidateHoneypotSet(selectedHoneypotSet) {
	var validationErrors = [];                
	if (!selectedHoneypotSet.name || selectedHoneypotSet.name === '') {                    
		addErrorMessage(validationErrors, 'name', 'Honeypot set name is empty');
	}
	if (!selectedHoneypotSet.startDate || selectedHoneypotSet.startDate === '') {
		addErrorMessage(validationErrors, 'startDate', 'Honeypot set start date is empty');
	}
	
	return validationErrors;
}

function addErrorMessage(validationErrors, field, message) {      
	validationErrors.push({ field: field, errorMessage: message});      
}

export default ValidateHoneypotSet;